import { Title, Flex, Button, Drawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChartArrowsVertical } from '@tabler/icons-react';

import { PaymentsFilter, PaymentsTable, PaymentsStats, useGetPayments } from '@/modules/payments';

export const Payments = () => {
  const {
    params,
    items: payments,
    itemsCount: paymentsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  } = useGetPayments();

  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Платежи</Title>
        <Button
          variant="outline"
          size="compact-md"
          fz={14}
          leftSection={<IconChartArrowsVertical size={14} />}
          onClick={open}
        >
          Статистика
        </Button>
      </Flex>

      <PaymentsFilter
        onSubmit={handleFilterChange}
        onReset={handleFilterReset}
      />

      <PaymentsTable
        items={payments}
        isLoading={isLoading}
        itemsCount={paymentsCount}
        pageSize={params.pageSize}
        currentPage={params.page}
        onPageChange={handlePaginationChange}
      />

      <Drawer
        opened={opened}
        onClose={close}
        title="Статистика платежей"
        position="right"
      >
        <PaymentsStats />
      </Drawer>
    </>
  );
};
